import React, {Component} from 'react'
import {Button} from "react-bootstrap";
import '../styles/SesjaWygasla.css'
import WyszukiwarkaService from "../wyszukiwarka/WyszukiwarkaService";

export default class SesjaWygasla extends Component {

    constructor(props) {
        super(props);

        this.state = {
            konfig: ''
        }
    }

    componentDidMount() {
        WyszukiwarkaService.getKonfigWartosc('Ile minut w koszyku', 'Bilety')
            .then(function (response) {
                let res = response.data;
                this.setState({konfig: res})
            }.bind(this))
    }

    render() {
        return <div className="sesjaWygasla">
            <div className="komunikat">
                <h4>Twój koszyk został wyczyszczony.</h4>
                Pozycje w koszyku mogą być utrzymywane przez {this.state.konfig} minut.
                <div>Wyszukaj i zaplanuj podróż ponownie.</div>
                <Button onClick={() => this.props.setSesja()}
                        style={{background: '#eeb207', color: 'white'}}>Zamknij</Button>
            </div>
        </div>
    }


}



// WEBPACK FOOTER //
// ./src/components/shared/SesjaWygasla.js